// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1jMA4","disabled":"FileBtn_disabled__39VtB","warn":"FileBtn_warn__12i0c","fade":"FileBtn_fade__2uYBr"};